import emailjs from 'emailjs-com';
import '../Css/FormContact.css';
import '../App.css';
import { useState } from 'react';


export default function ContactUs() {

  const [contactData,setContactData] = useState(0);
  const [errors, setErrors] = useState({});
  const [countChar, setCountChar] = useState(0);


  const handleChange = (e) =>{
    setContactData(prev=>({...prev, [e.target.name]: e.target.value }));
    if (contactData.html_message != undefined) {
      setCountChar(contactData.html_message.length);
    }
  }

  function sendEmail(e) {

    e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

    const newErrors = validateForm(contactData);
    setErrors(newErrors);
    

    if(Object.keys(newErrors).length === 0)
    {
       emailjs.sendForm('service_it314ns', 'template_ts0uxeo', e.target, 'UEakc9hHRG8C9ymHG')
      .then((result) => {
          window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior) 
      }, (error) => {
          console.log(error.text);
      });
    }
    else
    {
      console.log("Email n'a pas pu être envoyé");
    }
   
  }

  const validateForm = (data) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const errors = {};

    if (data.from_name === "" || data.from_name === undefined) {
        errors.from_name = 'Veuillez entrer votre nom et prénom';
    }

    if (data.subject === "" || data.subject === undefined) {
      errors.subject = "Veuillez entrer l'objet de votre message";
    }

    if (data.from_email === "" || data.from_email === undefined) {
        errors.from_email = 'Veuillez entrer votre email';
    } else if (!data.from_email.toLowerCase().match(re)) {
        errors.from_email = "Email n'est pas valide";
    }
    if (data.html_message === "" || data.html_message === undefined) {
      errors.html_message = "Ecrivez nous un petit message";
    }
    
    if (countChar > 300) {
        errors.html_message = 'Votre commentaire doit faire moins de 300 caractères';
    }
    return errors;
  }

  return (
    <div id='formulaireContainer' className='section-border-top'>
      <div className='section-title'>Travaillons ensemble !</div>
            <div className='HLContainer'><div className='big-line'></div></div>
        <div id='formulaireContact'>
            <form className="contact-form" onSubmit={sendEmail}>
              <label className='text'>Nom & Prénom*</label>
              <input type="text" name="from_name" onChange={handleChange}  />
                {errors.from_name && (
                  <p className="error-message">
                      {errors.from_name}
                  </p>
                )}
              <label className='text'>Email*</label>
              <input type="text" name="from_email" onChange={handleChange}/>
                {errors.from_email && (
                  <p className="error-message">
                      {errors.from_email}
                  </p>
                )}
              <label className='text'>Objet du message*</label>
              <input type="text" name="subject" onChange={handleChange}/>
                {errors.subject && (
                  <p className="error-message">
                      {errors.subject}
                  </p>
                )}
              <label className='text'>Message*</label>
              <textarea name="html_message" onChange={handleChange}/>
              <div className="message-label-container">
                <div className="textarea-error-message">
                  {errors.html_message && (
                    <p className="error-message">
                        {errors.html_message}
                    </p> 
                  )}
                </div>
              <label className="char-count">{countChar}/300</label>
            </div>
              <input type="submit" value="Envoyer" />
            </form>
        </div>
    </div>
    
  );
}